//-----------------------------------------------------------------------------
//----- Copyright deersoft 2015 - 2018 www.deersoft.de
//-----------------------------------------------------------------------------
import React, { Component } from 'react';
import LocalizedStrings from "../../localization/AboutDialog";
import LRModal from '../Basics/BasicModal';
import { globalCallbacks } from "../../util/callback";
import {QRCodeCanvas} from "qrcode.react"


import ChromeSecure from "../../content/img_new/ChromeSecure.png";
import { Message } from 'semantic-ui-react';


//-----------------------------------------------------------------------------
// The component for the TreeControl
class VRDialog extends Component 
{
  constructor(props)
  {
    super(props);
    this.state = 
    { 
      open : false,
    }
  }

  componentDidMount = () => 
  {
    this.setUpCallbacks();
  }

  show = async() => 
  {
    let info = await window.LR_GetVersionInfo()
    this.setState( { 
        open : true, 
        BaseURL: info.BaseURL,
        WebsocketPort: info.WebsocketPort,
        WebServerPort: info.WebServerPort,
        WebsocketURL: info.WebsocketURL,
      });
  }

  close = () => 
  {
    this.setState({open : false});
  }
    
  render() 
  {
    let open = this.state.open;
    if(!open) {return <div/>}

    return (
      <LRModal  open={open} 
                onCancelClick={this.close} 
                closeOnDimmerClick={false} 
                size="medium"
                scrolling={false}
                title={LocalizedStrings.Header}
                noCancel
                onOkClick={this.close}>
          <QRCodeCanvas size={450} value={`https://www.oculus.com/open_url/?url=http://${this.state.WebsocketURL}:${this.state.WebServerPort}/local-view?url=${this.state.WebsocketURL}:${this.state.WebsocketPort}`} />
          <br/>
          <h1>{`http://${this.state.WebsocketURL}:${this.state.WebServerPort}/local-view?url=${this.state.WebsocketURL}:${this.state.WebsocketPort}`}</h1>
          <img  src={ChromeSecure}  style={{maxWidth: "100%", height: "auto", display: "block", margin: "0 auto"}}/>        
          <Message>
            {LocalizedStrings.note}
            {LocalizedStrings.details}
            {LocalizedStrings.warning}
          </Message>
          <Message warning>
            {LocalizedStrings.instructions}
            {LocalizedStrings.final_step}
          </Message>
      </LRModal>
    )
  }

  setUpCallbacks()
  {

    globalCallbacks.ShowVRDialog = () => 
    { 
      this.show();
    }
    
  }
}

export default VRDialog